import AssignedUsers, { AssignesUsersProps } from './AssignedUsers.container';

export type AssignesUsersType = AssignesUsersProps;

export default AssignedUsers;
